import { useContext, useMemo } from 'react';

import {
  FolioSessionCommandsContext,
  FolioSessionContext,
  FolioSessionStateContext,
  type FolioSessionCommandsValue,
  type FolioSessionContextValue,
  type FolioSessionStateValue,
} from '@/hooks/folio-session-context';

function requireContext<T>(context: T | null, name: string): T {
  if (context === null) {
    throw new Error(`${name} must be used within FolioSessionProvider`);
  }

  return context;
}

export function useFolioSessionState(): FolioSessionStateValue {
  return requireContext(useContext(FolioSessionStateContext), 'useFolioSessionState');
}

export function useFolioSessionCommands(): FolioSessionCommandsValue {
  return requireContext(useContext(FolioSessionCommandsContext), 'useFolioSessionCommands');
}

export function useFolioSession(): FolioSessionContextValue {
  const state = useFolioSessionState();
  const commands = useFolioSessionCommands();
  const legacy = useContext(FolioSessionContext);

  return useMemo<FolioSessionContextValue>(
    () => legacy ?? { ...state, ...commands },
    [commands, legacy, state],
  );
}
